import React from 'react';
import { VITALES, mascara, errorVital, semaforo, claseImc } from './femoDef';

/* Constantes vitales y antropometría del FEMO (bloque E): una tarjeta por medida, con su ícono, el formato de entrada
   (solo números, la presión se escribe 12080 y queda 120/80, la temperatura 365 y queda 36.5), el rango normal y un
   semáforo referencial. El semáforo es una ayuda para adultos y no reemplaza el criterio del médico. */

export const css = `
.fx-vg{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:12px;}
.fx-v{border:1.5px solid var(--border);border-radius:12px;background:#fff;padding:10px 12px 9px;display:flex;flex-direction:column;gap:6px;transition:border-color .15s,background .15s;}
.fx-v.ok{border-color:#bfe3cd;} .fx-v.ojo{border-color:#f3d79c;background:#fffcf4;} .fx-v.bajo{border-color:#b9d3f2;background:#f7fbff;}
.fx-v.alto{border-color:#f0b9b9;background:#fff8f8;} .fx-v.critico{border-color:#e08a8a;background:#fff2f2;} .fx-v.err{border-color:#d66;background:#fff5f5;}
.fx-v-h{display:flex;align-items:center;gap:8px;}
.fx-ico{width:34px;height:34px;border-radius:10px;background:var(--blue-lt);color:var(--navy);display:inline-flex;align-items:center;justify-content:center;flex:none;}
.fx-v.ok .fx-ico{background:#e6f5ed;color:#1a7a4a;} .fx-v.ojo .fx-ico{background:#fff3e0;color:#b85c00;} .fx-v.bajo .fx-ico{background:#e3effc;color:#1b5fa8;}
.fx-v.alto .fx-ico,.fx-v.critico .fx-ico,.fx-v.err .fx-ico{background:#fdeaea;color:#b03030;}
.fx-ico svg{width:20px;height:20px;stroke:currentColor;fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;}
.fx-v-h label{font-size:11.5px;font-weight:700;color:var(--text2);line-height:1.2;cursor:pointer;}
.fx-v-h label i{color:#c33;font-style:normal;}
.fx-v-in{position:relative;}
.fx-v-in input{width:100%;font-size:22px;font-weight:700;letter-spacing:.3px;padding:6px 64px 6px 10px;font-variant-numeric:tabular-nums;}
.fx-v-in .u{position:absolute;right:10px;top:50%;transform:translateY(-50%);font-size:11px;font-weight:700;color:var(--text3);pointer-events:none;}
.fx-v-f{display:flex;align-items:center;justify-content:space-between;gap:6px;min-height:20px;font-size:10.5px;color:var(--text3);}
.fx-b{font-size:10.5px;font-weight:700;border-radius:99px;padding:2px 9px;white-space:nowrap;}
.fx-b.ok{background:#e6f5ed;color:#1a7a4a;} .fx-b.ojo{background:#fff3e0;color:#b85c00;} .fx-b.bajo{background:#e3effc;color:#1b5fa8;}
.fx-b.alto,.fx-b.critico{background:#fdeaea;color:#b03030;}
.fx-e{font-size:11px;color:#b03030;font-weight:600;}
.fx-imcbar{position:relative;height:10px;border-radius:99px;margin:6px 4px 2px;background:linear-gradient(90deg,#5b9bd5 0 14%,#4caf7d 14% 40%,#f1b24a 40% 60%,#e57373 60% 100%);}
.fx-imcbar i{position:absolute;top:-4px;width:4px;height:18px;border-radius:2px;background:var(--navy);transform:translateX(-50%);box-shadow:0 0 0 2px #fff;}
.fx-imcleg{display:flex;justify-content:space-between;font-size:9.5px;color:var(--text3);padding:0 2px;}
.fx-imcv{font-size:22px;font-weight:700;color:var(--navy);font-variant-numeric:tabular-nums;}
`;

const PATHS = {
  temp: <><path d="M14 14.8V4.5a2.5 2.5 0 0 0-5 0v10.3a4.5 4.5 0 1 0 5 0z" /><path d="M11.5 9v8" /></>,
  pa: <><path d="M4 17a8 8 0 1 1 16 0" /><path d="M12 17l3.5-5" /><circle cx="12" cy="17" r="1.2" /><path d="M5 20h14" /></>,
  fc: <><path d="M12 20.5s-7.5-4.6-9-9.3A4.9 4.9 0 0 1 12 8a4.9 4.9 0 0 1 9 3.2c-1.5 4.7-9 9.3-9 9.3z" /><path d="M6.5 12.2h3l1.4-2.6 2 5 1.3-2.4h2.3" /></>,
  fr: <><path d="M9 4v7.5c0 3-1.6 5.8-5 7 0-5 .8-9.2 3-13" /><path d="M15 4v7.5c0 3 1.6 5.8 5 7 0-5-.8-9.2-3-13" /><path d="M12 3v8" /></>,
  spo2: <><path d="M12 3s6 6.4 6 11a6 6 0 0 1-12 0c0-4.6 6-11 6-11z" /><text x="12" y="17" fontSize="6.5" textAnchor="middle" fill="currentColor" stroke="none" fontWeight="700">O₂</text></>,
  peso: <><rect x="3.5" y="4" width="17" height="16" rx="3.5" /><path d="M8 10.5a4 4 0 0 1 8 0" /><path d="M12 10.5l2-2" /></>,
  talla: <><path d="M12 3v18" /><path d="M8.5 6.5L12 3l3.5 3.5" /><path d="M8.5 17.5L12 21l3.5-3.5" /><path d="M5 12h3M16 12h3" /></>,
  cintura: <><path d="M8 3h8l-1.2 7L16 21H8l1.2-11z" /><path d="M6.5 12.5c3.3 2.2 7.7 2.2 11 0" /></>,
  imc: <><circle cx="12" cy="5" r="2" /><path d="M12 7.5v6" /><path d="M8 10h8" /><path d="M12 13.5l-3 6M12 13.5l3 6" /></>,
};
export const Icono = ({ n }) => <span className="fx-ico" aria-hidden="true"><svg viewBox="0 0 24 24">{PATHS[n]}</svg></span>;

export default function Vitales({ e, set, sexo, imc }) {
  const val = k => (e[k] == null ? '' : String(e[k]));
  const ci = claseImc(imc);
  return (
    <div className="fx-vg">
      {VITALES.map(v => {
        const valor = val(v.k);
        const err = errorVital(v.k, valor);
        const sem = semaforo(v.k, valor, { sexo });
        const req = v.k !== 'perimetro';
        const id = 'fx-v-' + v.k;
        return (
          <div key={v.k} className={'fx-v ' + (err ? 'err' : sem ? sem.nivel : '')}>
            <div className="fx-v-h">
              <Icono n={v.icono} />
              <label htmlFor={id}>{v.label}{req && <i> *</i>}</label>
            </div>
            <div className="fx-v-in">
              <input id={id} className="form-control" type="text" inputMode={v.mod} autoComplete="off" placeholder={v.ph}
                value={valor} aria-invalid={!!err} aria-describedby={id + '-ayuda'}
                onChange={ev => set(['e', v.k], mascara(v.k, ev.target.value, valor))} />
              <span className="u">{v.unidad}</span>
            </div>
            {err ? <div className="fx-e" role="alert">{err}</div>
              : <div className="fx-v-f" id={id + '-ayuda'}>
                <span>{sem ? v.ref : v.ayuda}</span>
                {sem && <span className={'fx-b ' + sem.nivel}>{sem.texto}</span>}
              </div>}
          </div>);
      })}
      <div className={'fx-v ' + (ci ? ci.nivel : '')}>
        <div className="fx-v-h"><Icono n="imc" /><label>Índice de masa corporal</label></div>
        <div className="fx-imcv">{imc != null ? imc : '—'} <small style={{ fontSize: 11, color: 'var(--text3)' }}>kg/m²</small></div>
        {ci ? (
          <>
            <div className="fx-imcbar" aria-hidden="true"><i style={{ left: ci.pos + '%' }} /></div>
            <div className="fx-imcleg" aria-hidden="true"><span>15</span><span>18.5</span><span>25</span><span>30</span><span>40</span></div>
            <div className="fx-v-f"><span>Se calcula con peso y talla</span><span className={'fx-b ' + ci.nivel}>{ci.texto}</span></div>
          </>
        ) : <div className="fx-v-f"><span>Se calcula solo con peso y talla</span></div>}
      </div>
    </div>
  );
}
